/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceCheckIn
 */
export interface WorkspaceCheckIn {
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCheckIn
     */
    mountpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCheckIn
     */
    protocol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceCheckIn
     */
    address?: string | null;
}

export function WorkspaceCheckInFromJSON(json: any): WorkspaceCheckIn {
    return WorkspaceCheckInFromJSONTyped(json, false);
}

export function WorkspaceCheckInFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceCheckIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mountpoint': !exists(json, 'mountpoint') ? undefined : json['mountpoint'],
        'protocol': !exists(json, 'protocol') ? undefined : json['protocol'],
        'address': !exists(json, 'address') ? undefined : json['address'],
    };
}

export function WorkspaceCheckInToJSON(value?: WorkspaceCheckIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mountpoint': value.mountpoint,
        'protocol': value.protocol,
        'address': value.address,
    };
}


